import * as Generated from 'gql';

export type Phone = Generated.Phone;

const FIELDS = 'number type';

export const Phone = {
  Fields: FIELDS
};
